<template>
  <b-modal
    v-model="modal.visible"
    hide-header-close
    no-close-on-esc
    no-close-on-backdrop
    scrollable
    title-tag="h3"
    title="Review Request">
    <template slot="modal-footer" align-h="between">
      <b-button align-self="start" variant="primary" @click="confirm">Confirm and Submit</b-button>
      <b-button variant="info" @click="close">Modify Order</b-button>
    </template>


    <p>
      <!-- <strong>OrderNum:</strong> {{this.ordernum}}<br> -->
      <strong>Department:</strong> {{this.department}}<br>
      <strong>Notes:</strong> <i>{{this.notes.text}}</i><br>
      <strong>Project:</strong> <i>{{this.notes.project}}</i><br>
    </p>
    <!-- <b-card id="items" hide-header hide-footer> -->
      <h5 v-if="soitems.length > 0"><i>Order Items:</i></h5>
      <ul class="my-3">
        <li v-for="item in soitems">
          <p>{{item.qty}}x <strong>{{item.num.toUpperCase()}}</strong>, <i>{{item.desc}}</i></p>
        </li>
      </ul>
      <h5 v-if="specialitems.length > 0"><i>Non-products to be requested via email:</i></h5>
      <ul class='my-3'>
        <li v-for="item in specialitems">
          <p>{{item.qty}}x <strong>{{item.num.toUpperCase()}}</strong>, <i>{{item.desc}}</i></p>
        </li>
      </ul>
    <!-- </b-card> -->
  </b-modal>
</template>

<script>

export default {
  name: 'review-modal',
  props: {
    soitems: {
      type: Array,
    },
    specialitems: {
      type: Array,
    },
    notes: '',
    ordernum: '',
    department: '',
    visible: false,
  },
  data () {
    return {
      modal: {
        visible: this.visible
      },
    }
  },
  methods: {
    confirm() {
      this.$emit("confirm");
    },
    close() {
      this.$emit("close");
    }
  },
  watch: {
    visible: function(){
      this.modal.visible = this.visible;
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/sales-order/inventory-request/ReviewModal.vue